import { MathJax } from "better-react-mathjax";
import { Link } from "react-router-dom";
import P, { P2 } from "../../components/Paragraph";
import Loader from "../../components/Loader";
import useAssignmentItem from "./hooks/useAssignmentItem";
import styles from "./assignmentList.module.css";
import classNames from "classnames";

const AssignmentItem = ({ assignment }) => {
  const {
    assignmentLabel,
    assignmentProgress,
    assignedDateLabel,
    dueDateLabel,
    problems,
    assignmentDetailsLoading,
    assignmentCompleted,
    handleProblemClick,
  } = useAssignmentItem({ assignment });

  const problemList = assignmentDetailsLoading ? null : (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "var(--gap-base)",
        marginTop: "var(--padding-section-header)",
        marginBottom: "var(--padding-section-bottom)",
        marginLeft: "var(--size-8)",
      }}
    >
      {problems?.map((problem) => (
        <Link
          key={problem?.id}
          onClick={(e) => {
            if (problem?.dialog_id == null) {
              e.preventDefault();
              handleProblemClick(problem?.id);
            }
          }}
          to={problem?.dialog_id ? `/problems/${problem?.dialog_id}` : "#"}
          className={classNames(styles.assignmentListItem, {
            [styles.linkStrike]: problem?.status === "FINISHED",
          })}
        >
          <MathJax inline dynamic>
            {problem?.problem_statement}
          </MathJax>
        </Link>
      ))}
    </div>
  );

  return (
    <div>
      <div>
        <div
          className={classNames(styles.assignmentListItem, {
            [styles.linkStrike]: assignmentCompleted,
          })}
        >
          <P>{assignmentLabel}</P>
          {assignmentDetailsLoading ? (
            <Loader small />
          ) : (
            <>
              <P>{assignmentProgress ? assignmentProgress : null}</P>
            </>
          )}
        </div>
        {assignmentDetailsLoading || assignmentCompleted ? null : (
          <div className={styles.assignmentListItem}>
            <P2>{assignedDateLabel ? assignedDateLabel : null}</P2>
            <P2>{dueDateLabel ? dueDateLabel : null}</P2>
          </div>
        )}
      </div>
      {problemList}
    </div>
  );
};

export default AssignmentItem;
